import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import getConfig from 'next/config';
import {
  mapApiException,
  reportApiException,
} from '../infrastructure/api/backend/interceptors';
import { getCookie } from './cookie';
import { coubicLocale } from './i18n';

const { publicRuntimeConfig } = getConfig();
let uaType = '';
let coubicLocaleString: coubicLocale | '' = '';

export function setUaType(uatype: string) {
  uaType = uatype || '';
}

export function setCoubicLocaleRequestHeader(locale: coubicLocale) {
  coubicLocaleString = locale;
}

// Intercepters
const setAccessTokenToHeader = (
  request: AxiosRequestConfig,
  session: string,
  token: string,
) => {
  if (token) {
    request.headers.common['Access-Token'] = token;
  }

  if (session) {
    request.headers.Cookie = `cb=${session};`;
  }

  return request;
};

const setApiCoubicLocaleHeader = (request: AxiosRequestConfig) => {
  request.headers['X-Coubic-Locale'] = coubicLocaleString;
  return request;
};

const setApiEnvHeader = (request: AxiosRequestConfig) => {
  request.headers.common['Api-Env'] = publicRuntimeConfig.coubicEnv;
  return request;
};

const setUaTypeHeader = (request: AxiosRequestConfig) => {
  request.headers.common.Uatype = uaType;
  return request;
};

// For SSR
export const newSecuredAxios = (
  session: string,
  token: string,
  requestId: string,
): AxiosInstance => {
  const ax = axios.create();

  ax.interceptors.request.use((request: AxiosRequestConfig) => {
    // if session is blank, fetch from cookie
    // need to fetch when intercepting for client side login
    session = session || getCookie('cb') || '';
    token = token || getCookie('token') || '';

    return setAccessTokenToHeader(request, session, token);
  });
  ax.interceptors.request.use((request: AxiosRequestConfig) => {
    request.headers['X-Request-Id'] = requestId;
    return request;
  });
  ax.interceptors.request.use(setApiCoubicLocaleHeader);
  ax.interceptors.request.use(setApiEnvHeader);
  ax.interceptors.request.use(setUaTypeHeader);
  ax.interceptors.response.use(undefined, reportApiException);
  ax.interceptors.response.use(undefined, mapApiException);

  return ax;
};

// For CSR
const securedAxios = ((): AxiosInstance => {
  const ax = newSecuredAxios('', '', '');

  ax.interceptors.request.use(req => {
    // TODO remove comment out after check if this instance is not used by SSR
    /*
    if (!isBrowser) { // TODO need to import from ./cookie
      throw new Error(
        // tslint:disable-next-line: quotemark
        "Don't use this axios on ServiceSide. use newSecuredAxios",
      );
    }
    */

    return req;
  });

  return ax;
})();

export default securedAxios;
